/**
 * @generated SignedSource<<b272ab3039bae33082b51363f6262b85>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type actorSection_auditEvent$fragmentType = any;
type contextSection_auditEvent$fragmentType = any;
type eventSection_auditEvent$fragmentType = any;
type subjectSection_auditEvent$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type Drawer_auditEvent$fragmentType: FragmentType;
export type Drawer_auditEvent$data = {|
  +$fragmentSpreads: actorSection_auditEvent$fragmentType & contextSection_auditEvent$fragmentType & eventSection_auditEvent$fragmentType & subjectSection_auditEvent$fragmentType,
  +$fragmentType: Drawer_auditEvent$fragmentType,
|};
export type Drawer_auditEvent$key = {
  +$data?: Drawer_auditEvent$data,
  +$fragmentSpreads: Drawer_auditEvent$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Drawer_auditEvent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "eventSection_auditEvent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "subjectSection_auditEvent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "actorSection_auditEvent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contextSection_auditEvent"
    }
  ],
  "type": "AuditEvent",
  "abstractKey": null
};

(node/*: any*/).hash = "bab052397a97bb5d7b6a24b6bebe5398";

module.exports = ((node/*: any*/)/*: Fragment<
  Drawer_auditEvent$fragmentType,
  Drawer_auditEvent$data,
>*/);
